exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{margin:0;padding:0}body,html{width:100vw;min-height:100vh}.mint-actionsheet-listitem{font-size:24px!important}.vxe-table--render-default.size--mini{font-size:14px!important}.ant-input[disabled],.ant-select-disabled{color:#000!important}.app{width:85vw!important}", ""]);

// exports
